import React, { useState } from 'react';
import { Box, TextField, Button, Typography, List, ListItem, ListItemText } from '@mui/material';
import { useGetAllMessagesQuery } from 'slices/chatApi';

const ChatView = ({ selectedChat }) => {
    const id = selectedChat.product_id;
    const from = selectedChat.from;
    const to = selectedChat.to;
    const [message, setMessage] = useState('');
  
    const { data, isLoading, error } = useGetAllMessagesQuery({ from, to, id });
    console.log('sms list------------->', data);

    return (
        <Box sx={{ padding: '10px' }}>
            <Typography variant="h6" gutterBottom>{selectedChat.name}</Typography>

            <List sx={{ maxHeight: '300px', overflowY: 'auto' }}>
                {data && data.length > 0 && data.map((msg, index) => (
                    <ListItem 
                        key={index} 
                        sx={{ 
                            display: 'flex', 
                            justifyContent: msg.from === from ? 'flex-end' : 'flex-start' 
                        }}
                    >
                        <Box
                            sx={{
                                backgroundColor: msg.from === from ? '#cce5ff' : '#f0f0f0',
                                padding: '8px 16px',
                                borderRadius: '16px',
                                maxWidth: '60%',
                                textAlign: 'left'
                            }}
                        >
                            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                {msg.sender}
                            </Typography>
                            <Typography variant="body2">
                                {msg.message}
                            </Typography>
                        </Box>
                    </ListItem>
                ))}
            </List>
            
            {/* Commented out message input for now */}
            {/* <Box display="flex" alignItems="center" mt={2}>
                <TextField
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Type a message..."
                    variant="outlined"
                    fullWidth
                    size="small"
                />
                <Button variant="contained" color="primary" sx={{ ml: 1 }}>
                    Send
                </Button>
            </Box> */}
        </Box>
    );
};

export default ChatView;
